import AlertDialogOnClose from "../../../../components/admin/AlertDiologOnClose";
import ListaAmbientes from "./ListaAmbientes";
export default function AmbienteForm() {

    return (
        <AlertDialogOnClose nome={"Ambiente"} placeholder={"Insira o nome do ambiente"}>
            <ListaAmbientes/>
        </AlertDialogOnClose>
    )
} 